module.exports = __webpack_public_path__ + "static/media/fel_logo.7846f162.svg";